import { render, staticRenderFns } from "./SendAnnouncement.vue?vue&type=template&id=b0619a0e&scoped=true&"
import script from "./SendAnnouncement.vue?vue&type=script&lang=js&"
export * from "./SendAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./SendAnnouncement.vue?vue&type=style&index=0&id=b0619a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0619a0e",
  null
  
)

export default component.exports